/** @format */

import {PeriodButton, Root} from './styles';
import {PeriodLiteModel} from './model';

interface Props {
  model: PeriodLiteModel[];
  currentPeriod: number;
  onPeriodClick: (key: number) => void;
}

const PeriodSelectorLite = ({model, currentPeriod, onPeriodClick}: Props) => {
  return (
    <Root data-testid='period-selector-lite'>
      {model.map(item => (
        <PeriodButton
          key={item.days}
          isSelected={item.days === currentPeriod}
          onClick={() => onPeriodClick(item.days)}
        >
          {item.name}
        </PeriodButton>
      ))}
    </Root>
  );
};

export {PeriodSelectorLite};
